/**
 * Hook for fetching audit sessions data specifically for header aggregates
 *
 * This hook always fetches the maximum 100 sessions (API limit) to provide
 * accurate aggregate statistics in the header, independent of table pagination.
 */

import { useGetAuditSessions, type PaginationOptions } from './useGetAuditSessions';

/**
 * Hook to get audit sessions for header aggregates
 * Always fetches maximum 100 sessions for accurate statistics
 */
export function useGetAuditSessionsForHeader(communityId: string | undefined) {
  // Fixed pagination options for header - always get max 100 sessions for aggregates
  const headerPaginationOptions: PaginationOptions = {
    page: 1,
    pageSize: 100, // Maximum allowed by API
  };

  const { sessions, community, loading, error, refetch } = useGetAuditSessions(communityId, headerPaginationOptions);

  return {
    headerSessions: sessions,
    community,
    headerLoading: loading,
    headerError: error,
    refetchHeader: refetch,
  };
}
